const BUSINESS_TYPES = [
  {
    label: "Comerciante Agrícola / Tienda Agrícola",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "Refugio de Animales / Caridad",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "Lote de Engorde",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  {
    label: "Productor de Carne de Vacuno",
    value: "Beef Producer",
    id: "beef_producer",
  },
  { label: "Pollos de Engorde", value: "Broilers", id: "broilers" },
  {
    label: "Grupo de Compra",
    value: "Buying Group",
    id: "buying_group",
  },
  {
    label: "Producción de Terneros",
    value: "Calf Production",
    id: "calf_production",
  },
  {
    label: "Rancho/Desarrollador de Terneros",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  { label: "Comprador de Ganado", value: "Cattle Buyer", id: "cattle_buyer" },
  {
    label: "Cultivador por Contrato",
    value: "Contract Grower",
    id: "contract_grower",
  },
  { label: "Cooperativa", value: "Cooperative", id: "cooperative" },
  {
    label: "Oficina Corporativa",
    value: "Corporate Office",
    id: "corporate_office",
  },
  {
    label: "Operación Vaca/Ternero",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "Producción Láctea",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "Distribuidor / Agente",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "Fábrica de Piensos", value: "Feed Mill", id: "feed_mill" },
  { label: "Cebadero", value: "Feedyard", id: "feedyard" },
  {
    label: "Cultivador/Cebadero",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "Incubadora", value: "Hatchery", id: "hatchery" },
  {
    label: "Producción de Novillas",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "Integración de Ponedoras",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "Ponedoras", value: "Layers", id: "layers" },
  { label: "Medios de Comunicación", value: "Media", id: "media" },
  {
    label: "Cooperativa/Comprador de Leche",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "Productor Mixto/Otro",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "Proveedor de Nutrientes",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "Empacador/Procesador",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "Tienda Minorista de Mascotas",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "Farmacia", value: "Pharmacy", id: "pharmacy" },
  {
    label: "Criador de Aves de Corral",
    value: "Poultry Breeder",
    id: "poultry_breeder",
  },
  {
    label: "Integrador Avícola",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  {
    label: "Productor de Ovejas",
    value: "Sheep Producer",
    id: "sheep_producer",
  },
  {
    label: "Operación de Engorde",
    value: "Stocker Operation",
    id: "stocker_operation",
  },
  {
    label: "Corral de Ganado/Mercado",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  {
    label: "Productor de Cerdos",
    value: "Swine Producer",
    id: "swine_producer",
  },
  { label: "Pavos", value: "Turkeys", id: "turkeys" },
  {
    label: "Universidad / Educación",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "Clínica Veterinaria",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "Mayorista / Minorista",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "Comprador de Lana", value: "Wool Buyer", id: "wool_buyer" },
];
const FIELDS = {
  common: {
    errors: {
      required: "Requerido",
    },
  },
  salutation: {
    label: "Saludo",
    placeholder: "Seleccionar Saludo",
    errors: {
      required: "El saludo es obligatorio",
      invalid: "Por favor, seleccione un saludo válido",
    },
  },
  firstName: {
    label: "Nombre",
    placeholder: "Juan",
    errors: {
      authenticatedNameUpdateTrial:
        "Ha iniciado sesión y no puede cambiar su nombre.",
      required: "El nombre es obligatorio",
      minLength: "El nombre debe tener al menos 2 caracteres",
      maxLength: "El nombre debe tener como máximo 50 caracteres",
    },
  },
  lastName: {
    label: "Apellido",
    placeholder: "Pérez",
    errors: {
      authenticatedNameUpdateTrial:
        "Ha iniciado sesión y no puede cambiar su nombre.",
      required: "El apellido es obligatorio",
      minLength: "El apellido debe tener al menos 2 caracteres",
      maxLength: "El apellido debe tener como máximo 50 caracteres",
    },
  },
  email: {
    label: "Correo electrónico",
    placeholder: "juan.perez@example.org",
    description:
      "Por favor, introduzca una dirección de correo electrónico que sea personal para usted, no una dirección de correo electrónico compartida.",
    prefixWarningTitle: "Buzón compartido detectado",
    prefixWarningDescription:
      "Recomendamos usar una dirección de correo electrónico personal para una experiencia personalizada superior",
    errors: {
      authenticatedEmailUpdateTrial:
        "Ha iniciado sesión y no puede cambiar su correo electrónico.",
      required: "El correo electrónico es obligatorio",
      invalidEmail:
        "Por favor, introduzca una dirección de correo electrónico válida",
      emailAssociatedWithYourAccount:
        "Su dirección de correo electrónico está asociada con su cuenta y no se puede cambiar.",
    },
  },
  confirmEmail: {
    label: "Confirmar correo electrónico",
    placeholder: "juan.perez@example.org",
    errors: {
      authenticatedEmailUpdateTrial:
        "Ha iniciado sesión y no puede cambiar su correo electrónico.",
      required: "La confirmación del correo electrónico es obligatoria",
      invalidEmail:
        "Por favor, introduzca una dirección de correo electrónico válida",
      emailMatchError: "Las direcciones de correo electrónico no coinciden",
    },
  },
  password: {
    label: "Contraseña",
    placeholder: "Introduzca su contraseña",
    errors: {
      required: "La contraseña es obligatoria",
    },
  },
  confirmPassword: {
    label: "Confirmar contraseña",
    placeholder: "Confirme su contraseña",
    errors: {
      required: "La confirmación de la contraseña es obligatoria",
      passwordMatchError: "Las contraseñas no coinciden",
    },
  },
  addressLine1: {
    label: "Dirección Línea 1",
    placeholder: "Calle Mayor 123",
    errors: {
      required: "La dirección Línea 1 es obligatoria",
      minLength: "La dirección Línea 1 debe tener al menos 5 caracteres",
      maxLength: "La dirección Línea 1 debe tener como máximo 100 caracteres",
    },
  },
  addressLine2: {
    label: "Dirección Línea 2",
    placeholder: "Piso 4B",
    errors: {
      required: "La dirección Línea 2 es obligatoria",
      maxLength: "La dirección Línea 2 debe tener como máximo 100 caracteres",
    },
  },
  city: {
    label: "Ciudad / Pueblo",
    placeholder: "Madrid",
    errors: {
      required: "La ciudad / el pueblo es obligatorio",
      minLength: "La ciudad / el pueblo debe tener al menos 2 caracteres",
      maxLength: "La ciudad / el pueblo debe tener como máximo 50 caracteres",
    },
  },
  country: {
    label: "País",
    placeholder: "Seleccionar país",
    errors: {
      required: "El país es obligatorio",
      invalid: "Seleccione un país válido",
    },
  },
  state: {
    label: "Provincia",
    placeholder: "Seleccionar Provincia",
    errors: {
      required: "La provincia es obligatoria",
      invalid: "Por favor, seleccione una provincia válida",
    },
  },
  jurisdiction: {
    label: "Jurisdicción de la Licencia",
    placeholder: "Seleccionar Jurisdicción de la Licencia",
    errors: {
      required: "La jurisdicción de la licencia es obligatoria",
      invalid: "Por favor, seleccione una jurisdicción válida",
    },
  },
  zipCode: {
    label: "Código Postal",
    placeholder: "28001",
    errors: {
      required: "El código postal es obligatorio",
      invalid: "Por favor, introduzca un código postal válido",
    },
  },
  role: {
    label: "Rol",
    placeholder: "Seleccione su rol",
    errors: {
      required: "Por favor, seleccione su rol",
      invalid: "Por favor, seleccione un rol válido",
    },
  },
  businessType: {
    label: "Tipo de Negocio",
    placeholder: "Seleccionar Tipo de Negocio",
    errors: {
      required: "El tipo de negocio es obligatorio",
      invalid: "Por favor, seleccione un tipo de negocio válido",
    },
  },
  businessName: {
    label: "Nombre del Negocio",
    placeholder: "Introduzca el nombre del negocio",
    errors: {
      required: "El nombre del negocio es obligatorio",
      minLength: "El nombre del negocio debe tener al menos 2 caracteres",
      maxLength: "El nombre del negocio debe tener como máximo 100 caracteres",
    },
  },
  businessSearch: {
    label: "Búsqueda de Negocios:",
    addNewAccount: "Añadir Nueva Cuenta de Negocio",
    canNotFindBusiness: "¿No encuentra su negocio?",
    guideline:
      "Por favor, introduzca su código postal y luego seleccione de la lista siguiente.",
    guidelineForNameSearch:
      "Por favor, introduzca el nombre completo del negocio y luego seleccione de la lista.",
    placeholder: "¿Dónde trabaja?",
    noResults: "No se encontraron resultados",
    searching: "Buscando...",
    selectedBusinessHeading: "Negocio Seleccionado:",
    selectedBusinessNotCorrect: "¿No es correcto?",
    selectedBusinessTryAgain: "Intentar de nuevo",
    selectedBusinessDismiss: "Descartar negocio",
    resultsFound: {
      singular: "1 negocio encontrado",
      plural: "Múltiples negocios encontrados",
    },
    errors: {
      network:
        "Estamos teniendo problemas para conectar con el buscador de negocios. Por favor, inténtelo de nuevo más tarde.",
    },
  },
  explicitConsent: {
    label:
      "Al marcar esta casilla, acepto recibir comunicaciones de marketing de Elanco.",
    errors: {
      required: "Se requiere consentimiento",
    },
  },
  explicitSmsConsent: {
    label:
      "Al marcar esta casilla, acepto recibir comunicaciones de marketing de Elanco por SMS/mensaje de texto.",
    errors: {
      required: "El consentimiento para SMS es obligatorio",
    },
  },
  telephone: {
    label: "Teléfono personal",
    placeholder: "Introduzca su teléfono personal",
    dialCodeLabel: "Código",
    dialCodePlaceholder: "Buscar país…",
    errors: {
      invalid: "Por favor, introduzca un número de teléfono válido.",
    },
  },
  businessTelephone: {
    label: "Teléfono de negocio",
    placeholder: "Introduzca su teléfono de negocio",
    dialCodeLabel: "Código",
    dialCodePlaceholder: "Buscar país…",
    errors: {
      invalid: "Por favor, introduzca un número de teléfono válido.",
    },
  },
  professionalNumber: {
    label: "Número Profesional",
    placeholder: "1234567",
    errors: {
      required: "Por favor, introduzca un número profesional",
      maxLength: "La entrada excede el límite de caracteres",
    },
  },
  addressSearch: {
    errors: {
      required: "Este campo es obligatorio",
    },
  },
  businessSearchField: {
    errors: {
      required: "Este campo es obligatorio",
    },
  },
  checkbox: {
    errors: {
      required: "Este campo es obligatorio",
    },
  },
  checkboxGroup: {
    errors: {
      required: "Este campo es obligatorio",
    },
  },
  combobox: {
    errors: {
      required: "Este campo es obligatorio",
    },
  },
  datePicker: {
    errors: {
      required: "Este campo es obligatorio",
    },
  },
  dateRange: {
    errors: {
      required: "Este campo es obligatorio",
    },
  },
  dateTime: {
    errors: {
      required: "Este campo es obligatorio",
    },
  },
  emailField: {
    errors: {
      required: "Este campo es obligatorio",
    },
  },
  fileInput: {
    errors: {
      required: "Por favor, seleccione un archivo",
    },
  },
  number: {
    errors: {
      required: "Por favor, introduzca un número",
      minValue: "Por favor, introduzca un valor superior al mínimo",
      maxValue: "Por favor, introduzca un valor inferior al máximo",
    },
  },
  passwordField: {
    errors: {
      required: "Este campo es obligatorio",
    },
  },
  rangeSlider: {
    errors: {
      required: "Este campo es obligatorio",
    },
  },
  select: {
    errors: {
      required: "Este campo es obligatorio",
    },
  },
  telephoneField: {
    errors: {
      required: "Por favor, introduzca solo números",
      invalidTelephone: "Por favor, introduzca un número de teléfono válido",
      invalidFormat: "Formato de número no válido",
    },
  },
  text: {
    errors: {
      required:
        "Por favor, utilice solo letras (A-Z), números (0-9) y ningún símbolo",
      maxLength: "La entrada excede el límite de caracteres",
      minLength: "La entrada debe tener al menos 2 caracteres",
    },
  },
  textarea: {
    characters: "caracteres",
  },
  time: {
    errors: {
      required: "Este campo es obligatorio",
    },
  },
  form: {
    errors: {
      generic:
        "Encontramos un error al enviar su formulario. Por favor, inténtelo de nuevo.",
      reportAnIssue: "Por favor, reporte un problema.",
      configuration: "Error de Configuración",
      noFormQuestionsAvailable: "No hay preguntas de formulario disponibles.",
      formComponentLoad:
        "El componente del formulario no se pudo cargar debido a un campo no compatible.",
      code: "Código",
      type: "Tipo",
      missingRequiredFields:
        "Este formulario no contiene los campos obligatorios (Correo electrónico y/o Consentimiento). Póngase en contacto con un administrador para corregir la configuración del formulario.",
    },
  },
};
const ROLES = [
  { value: "Academic", label: "Académico", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "Bienestar Animal - Otro",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "Bienestar Animal - Personal de Tienda",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "Bienestar Animal - Veterinario",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "Bienestar Animal - Enfermero Veterinario",
    id: "animal_welfare_vet_nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "Bienestar Animal - Voluntario",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "Extensión de Carne de Vacuno / Cebadero",
    id: "beef_feedlot_extension",
  },
  {
    value: "Beef Producer",
    label: "Productor de Carne de Vacuno",
    id: "beef_producer",
  },
  { value: "Breeder", label: "Criador", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "Administrador de Negocios / Recepcionista",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "Propietario / Socio de Negocio",
    id: "business_owner_partner",
  },
  { value: "Clinic Buyer", label: "Clinic Buyer", id: "clinic_buyer" },
  {
    value: "Consulting Nutritionist",
    label: "Nutricionista Consultor",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "Empleado Corporativo (no veterinario)",
    id: "corporate_employee_non_dvm",
  },
  {
    value: "Dairy Producer",
    label: "Productor Lácteo",
    id: "dairy_producer",
  },
  { value: "Distributor", label: "Distribuidor", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "Representante de Distribuidor, Campo",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "Representante de Distribuidor, Interno",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "Institución Educativa - Estudiante de Bachillerato",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "Institución Educativa - Estudiante TAFE",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "Institución Educativa - Estudiante Universitario",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "Peluquero de Mascotas", id: "groomer" },
  {
    value: "Marketing Associate",
    label: "Marketing Associate",
    id: "marketing_associate",
  },
  {
    value: "Medical / Clinic Director",
    label: "Director Médico / de Clínica",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "Nutrición / Ventas de Piensos",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "Profesional de la Nutrición",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "Nutricionista", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "Gerente de Oficina / Clínica",
    id: "office_practice_manager",
  },
  { value: "OTC Retailer", label: "Minorista OTC", id: "otc_retailer" },
  { value: "Pharmacist", label: "Farmacéutico", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "Farmacia - Personal",
    id: "pharmacy_staff",
  },
  { value: "Pig Producer", label: "Productor de Cerdos", id: "pig_producer" },
  {
    value: "Poultry Producer",
    label: "Productor Avícola",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "Propietario de Clínica (no veterinario)",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Purchasing Agent",
    label: "Purchasing Agent",
    id: "purchasing_agent",
  },
  {
    value: "Receptionist / Client Service",
    label: "Recepcionista / Servicio al Cliente",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "Tienda de Revendedor - Personal",
    id: "reseller_store_staff",
  },
  {
    value: "Producer - Mixed/Other",
    label: "Productor - Mixto/Otro",
    id: "producer_mixed_other",
  },
  { value: "Retail Staff", label: "Retail Staff", id: "retail_staff" },
  {
    value: "Retail Store Manager",
    label: "Retail Store Manager",
    id: "retail_store_manager",
  },
  {
    value: "Retailer",
    label: "Minorista",
    id: "retailer",
  },
  {
    value: "Sheep Producer",
    label: "Productor de ovejas",
    id: "sheep_producer",
  },
  { value: "SQP", label: "RAMA / SQP", id: "sqp" },
  { value: "Student", label: "Student", id: "student" },
  { value: "Student RAMA", label: "Estudiante RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "Veterinario/a",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "Entrenador", id: "trainer" },
  { value: "Veterinarian", label: "Veterinario", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "Veterinario, Propietario de Clínica",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "Asistente Veterinario",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "Enfermero Veterinario",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "Clínica Veterinaria - Otro",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "Clínica Veterinaria - Veterinario",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "Clínica Veterinaria - Enfermero Veterinario",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "Veterinario Especialista",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "Estudiante de Veterinaria",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "Cirujano Veterinario",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "Técnico Veterinario",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "Mayorista", id: "wholesaler" },
];
const SALUTATIONS = [
  {
    label: "Dr.",
    value: "Dr.",
    id: "dr",
  },
  {
    label: "M.",
    value: "M.",
    id: "m",
  },
  {
    label: "Señorita",
    value: "Miss",
    id: "miss",
  },
  {
    label: "Sr.",
    value: "Mr.",
    id: "mr",
  },
  {
    label: "Sra.",
    value: "Mrs.",
    id: "mrs",
  },
  {
    label: "Sra.",
    value: "Ms.",
    id: "ms",
  },
  {
    label: "Mx.",
    value: "Mx.",
    id: "mx",
  },
  {
    label: "Profesor",
    value: "Professor",
    id: "professor",
  },
];
export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
